module.exports = __webpack_public_path__ + "img/ic_48_faq_down--selected.32642d04.svg";